import { LoginForm } from '../../components/authentication/login';
import Page from '../../components/Page';

import logoLais from 'src/assets/logos/logo-lais1.png';
import logoEva from 'src/assets/logos/logo-eva.png';
import logoNimble from 'src/assets/logos/nimble.png';
import bgLogin from 'src/assets/bg-login.png';

// ----------------------------------------------------------------------

function getLogo() {
  const url = window.location.href;
  if (url.includes('eva')) return logoEva;
  if (url.includes('nimble')) return logoNimble;
  return logoLais;
}

export default function Login() {
  return (
    <Page title="Login">
      <div className="flex min-h-screen w-full animate-in fade-in duration-500">

        {/* Left Side — Background com imagem */}
        <div className="hidden lg:flex lg:w-[55%] relative overflow-hidden bg-gradient-to-b from-[#1a0a2e] via-[#160826] to-[#120620]">
          {/* Pattern overlay */}
          <div className="absolute inset-0 bg-[radial-gradient(rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:24px_24px]" />

          {/* Gradient glow */}
          <div className="absolute -bottom-32 -left-32 h-[500px] w-[500px] rounded-full bg-white/5 blur-3xl" />
          <div className="absolute -top-32 -right-32 h-[400px] w-[400px] rounded-full bg-[#a78bfa]/10 blur-3xl" />

          {/* Content */}
          <div className="relative z-10 flex flex-col justify-between w-full p-12">
            {/* Logo top */}
            <div>
              <img src={getLogo()} alt="Logo" className="h-8 w-auto brightness-0 invert" />
            </div>

            {/* Central — imagem + texto */}
            <div className="flex flex-col items-center gap-8">
              <img
                src={bgLogin}
                alt="Dashboard preview"
                className="w-full max-w-[480px] drop-shadow-2xl animate-in slide-in-from-bottom-6 duration-700"
              />
              <div className="text-center max-w-md">
                <h1 className="text-2xl font-bold text-white mb-3">
                  Gerencie tudo em um só lugar
                </h1>
                <p className="text-sm text-white/60 leading-relaxed">
                  Automatize conversas, gerencie equipes e acompanhe métricas em tempo real com a plataforma mais completa do mercado.
                </p>
              </div>
            </div>

            {/* Footer */}
            <p className="text-xs text-white/30">
              © {new Date().getFullYear()} Lais. Todos os direitos reservados.
            </p>
          </div>
        </div>

        {/* Right Side — Login form */}
        <div className="flex w-full lg:w-[45%] items-center justify-center bg-white px-6 sm:px-12">
          <div className="w-full max-w-[400px] animate-in fade-in slide-in-from-right-4 duration-500">
            {/* Logo mobile */}
            <div className="mb-8 lg:hidden flex justify-center">
              <img src={getLogo()} alt="Logo" className="h-9 w-auto" />
            </div>

            <div className="mb-8 space-y-2">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                Bem vindo de volta
              </h2>
              <p className="text-sm text-gray-500">
                Insira suas credenciais para acessar sua conta
              </p>
            </div>

            <LoginForm />

            <p className="mt-8 text-center text-xs text-gray-400">
              Protegido com criptografia de ponta a ponta
            </p>
          </div>
        </div>

      </div>
    </Page>
  );
}
